'use client'

import { MyPortfolio } from '@/containers/MyPortfolio'

export default function DashboardPage() {
  return <MyPortfolio />
}
